import { Configuration, PopupRequest } from "@azure/msal-browser";

export const msalConfig: Configuration={
    auth:{
        clientId:process.env.REACT_APP_AD_appId||'',
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AD_tenantID}`,
        redirectUri:process.env.REACT_APP_deploymentURL,
        postLogoutRedirectUri:process.env.REACT_APP_deploymentURL
    },
    cache:{
        cacheLocation:'localStorage',
        storeAuthStateInCookie:false
    },
    system:{
        allowNativeBroker: false
    },
}

export const loginRequest: PopupRequest={
    scopes: ["User.Read"]
}

export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};